import { BrowserRouter as Router } from "react-router-dom"
import Header from "./components/Header/Header";
import Switcher from "./components/Switcher";
import React, { useState } from "react"

function App() {
  const [isMessy, setIsMessy] = useState(false);

  return (
    <div>
      <Router >
        <Header setIsMessy={(e) => setIsMessy(e)} />
        <Switcher isMessy={isMessy} />
      </Router>
    </div>
  );
}

export default App;
